import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Box, Button, Grid, withWidth } from "@material-ui/core";
import {
  FilterBar,
  Container,
  DataGrid,
  Paginate,
  InputText,
  Dialog,
} from "src/components";

import { Cancel as CancelIcon, Delete as DeleteIcon } from "@material-ui/icons";

import {
  excluirEntregador,
  pesquisarEntregadores,
} from "src/store/actions/entregadores";
import * as types from "src/store/types/entregadores";
import { Plus as PlusIcon } from "react-feather";
import ModalEntregadores from "./ModalEntregadores";

function Entregadores({ width }) {
  const [entregador, setEntregador] = useState({});
  const [modal, setModal] = useState({ type: "", entregador: {} });

  const dispatch = useDispatch();
  const { filtro, page, perpage, total, entregadores, loading } = useSelector(
    (state) => state.entregadores
  );

  useEffect(() => {
    dispatch(
      pesquisarEntregadores({
        ...filtro,
        page,
        per_page: perpage,
      })
    );
  }, []);

  function limparfiltros() {
    dispatch([
      { type: types.SET_PAGE_ENTREGADOR, payload: 1 },
      { type: types.SET_FILTRO_ENTREGADORES, payload: { titulo: "" } },
      pesquisarEntregadores({ page: 1, per_page: perpage }),
    ]);
  }

  function handleChangePage(newPage) {
    dispatch([
      { type: types.SET_LOADING_ENTREGADOR, payload: true },
      { type: types.SET_PAGE_ENTREGADOR, payload: newPage + 1 },
      pesquisarEntregadores({
        ...filtro,
        page: newPage + 1,
        per_page: perpage,
      }),
    ]);
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.SET_LOADING_ENTREGADOR, payload: true },
      {
        type: types.SET_PERPAGE_ENTREGADOR,
        payload: parseInt(event.target.value, 10),
      },
      pesquisarEntregadores({
        ...filtro,
        page: 1,
        per_page: parseInt(event.target.value, 10),
      }),
    ]);
  };

  const handleFiltro = (value) => {
    dispatch({
      type: types.SET_FILTRO_ENTREGADORES,
      payload: value,
    });
  };

  const handleCloseModal = () => {
    setModal({ type: "" });
    setEntregador({});
  };

  const handleDelete = async () => {
    await excluirEntregador(entregador.id);
    handleCloseModal();
  };

  return (
    <Container title="Entregadores">
      <Dialog
        visible={modal.type === "delete"}
        title="Excluir entregador"
        contenttext="Deseja excluir o entregador ?"
        buttons={[
          {
            title: "Excluir",
            icon: <DeleteIcon />,
            onClick: handleDelete,
          },
          {
            title: "Fechar",
            icon: <CancelIcon />,
            onClick: handleCloseModal,
          },
        ]}
      />
      <ModalEntregadores
        open={modal.type !== "" && modal.type !== "delete"}
        close={handleCloseModal}
        entregador={modal.entregador}
      />
      <Box display="flex">
        <FilterBar
          fullWidth
          searchFilter={() => {
            dispatch(
              pesquisarEntregadores({ ...filtro, per_page: perpage, page })
            );
          }}
          clearFilter={limparfiltros}
          title="Clique aqui para visualizar as opções de filtro."
        >
          <Grid container spacing={2}>
            <Grid item sm={5}>
              <InputText
                label="Entregador"
                value={filtro.nome}
                onChange={(e) => handleFiltro({ nome: e.target.value })}
              />
            </Grid>
          </Grid>
        </FilterBar>
        <Button color="primary" onClick={() => setModal({ type: "insert" })}>
          <PlusIcon />
          Novo
        </Button>
      </Box>
      <PerfectScrollbar>
        <DataGrid
          isLoading={loading}
          columns={[
            {
              title: "ID",
              field: "id",
              width: 30,
            },
            {
              title: "Entregador",
              field: "nome",
              width: "auto",
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "CPF",
              field: "cpf",
            },
            {
              title: "Celular",
              field: "celular",
            },
            {
              title: "Veículo",
              field: "veiculo",
            },
            {
              title: "Placa",
              field: "placa",
            },
            {
              title: "Status",
              field: "situacao",
              lookup: { A: "ATIVO", I: "INATIVO" },
              width: 30,
              headerStyle: {},
              cellStyle: {},
            },
          ]}
          data={entregadores}
          actions={[
            {
              icon: () => <DeleteIcon color="primary" />,
              tooltip: "Extrato",
              onClick: (event, rowData) => {
                setEntregador(rowData);
                setModal({ type: "delete" });
              },
            },
          ]}
        />
      </PerfectScrollbar>
      <Paginate
        rowsPerPageOptions={[10, 25, 50]}
        rowsPerPage={perpage}
        count={total}
        page={page - 1}
        onChangePage={(event, newPage) => handleChangePage(newPage)}
        onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
      />
    </Container>
  );
}

export default withWidth()(Entregadores);
